"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EntitiesRenderer {
    constructor(key = null) {
        // the identifier for this kind of entity
        this.key = null;
        // entities
        this.items = [];
    }
    incoming(items = []) {
        this.items = items;
    }
    plotAll() {
    }
    unplotAll() {
    }
    plot(item = null) {
    }
    unplot(item = null) {
    }
}
exports.EntitiesRenderer = EntitiesRenderer;
